import { useParams } from 'react-router-dom'

type IParams = {
  id: string
}

interface IIsEditPage {
  projectId: number | undefined
  isEdit: boolean
}

/**
 * Custom hook to determine whether the current page is an edit page.
 *
 * @returns {Object} An object with two properties:
 *  - `isEdit`: a boolean indicating whether the current page is an edit page.
 *  - `projectId`: a string representing the project ID, retrieved from the location state.
 *
 * @example
 * const { isEdit, projectId } = useIsEditPage()
 * console.log(isEdit, projectId)
 */
export function useIsEditPage(): IIsEditPage {
  const { id } = useParams<IParams>()

  const isEdit = !!id

  return { isEdit, projectId: Number(id) }
}
